import { cn } from '@/shared/utils/cn';
import type { ReactNode } from 'react';

interface CustomizationChipProps {
  selected: boolean;
  onClick: () => void;
  children: ReactNode;
  className?: string;
}

export function CustomizationChip({
  selected,
  onClick,
  children,
  className,
}: CustomizationChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex h-[50px] w-[87px] shrink-0 items-center justify-center rounded-[10px] border text-[14px] font-semibold leading-[18px] tracking-[0.015em]',
        selected
          ? 'border-[var(--link-blue)] bg-[var(--link-blue)] text-white'
          : 'border-[#d9d9d9] bg-white text-black',
        className
      )}
    >
      {children}
    </button>
  );
}

interface CustomizationRowLabelProps {
  label: string;
}

export function CustomizationRowLabel({ label }: CustomizationRowLabelProps) {
  return (
    <div className="relative flex min-h-[72px] w-[90px] shrink-0 items-center justify-end bg-[#f5f5f5] px-2.5 shadow-[1px_0_3px_rgba(0,0,0,0.2)]">
      <span className="text-right text-[12px] font-semibold uppercase leading-[15px] tracking-[0.08em] text-black">
        {label}
      </span>
    </div>
  );
}
